/**
 * @fileoverview Post Content Controller - controller for the content of a post. Handles any
 * logic for how fields relate to each other, in addition to enabling/disabling fields based
 * on configuration
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.provide('yext.social.post.PostContentController');

goog.require('yext');
goog.require('yext.notify');
goog.require('yext.social.post.actions');
goog.require('yext.social.post.EventContentController');
goog.require('yext.social.post.EventContentView');
goog.require('yext.social.post.CallToActionView');
goog.require('yext.social.post.LinkContentView');
goog.require('yext.social.post.Partner');
goog.require('yext.social.post.PhotoContentView');
goog.require('yext.social.post.TextContentView');
goog.require('yext.social.post.actions');
goog.require('yext.socialstorm.routes');
goog.require('yext.youtube');
goog.require('yext.fileupload');

/** @constructor */
yext.social.post.PostContentController = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$ctxt = this.options.$ctxt || $('.js-post-content-container');

  /** @type {yext.social.post.LinkContentView} */
  this.linkContent = new yext.social.post.LinkContentView({
    $el: this.$ctxt.find('.js-post-link-container'),
    link: this.options.existingPost.link || '',
  }).init();

  /** @type {yext.social.post.PhotoContentView} */
  this.photoContent = new yext.social.post.PhotoContentView({
    $el: this.$ctxt.find('.js-post-photo-container'),
    getLocationSearchParam: this.options.getLocationSearchParam,
  }).init();

  /** @type {yext.social.post.TextContentView} */
  this.textContent = new yext.social.post.TextContentView({
    $el: this.$ctxt.find('.js-post-text-container'),
    message: this.options.existingPost.message || '',
  }).init();

  this.eventController = new yext.social.post.EventContentController();

  this.callToActionContent = new yext.social.post.CallToActionView();

  /**
   * @type {Function}
   * @private
   */
  this.onChange_ = null;
};

/** @return this */
yext.social.post.PostContentController.prototype.init = function() {
  this.bindLinkContentView_();
  this.bindPhotoContentView_();
  this.bindTextContentView_();
  this.updateFieldConfiguration();
  this.updateCharacterCount_();

  this.eventController.hide(!this.options.isFieldAllowedForAnyPartner(
    yext.social.post.Partner.PostField.EVENTS));
  this.callToActionContent.hide(!this.options.isFieldAllowedForAnyPartner(
    yext.social.post.Partner.PostField.CALL_TO_ACTION));
  return this;
};

/** @param {Function} cb */
yext.social.post.PostContentController.prototype.onChange = function(cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('PostContentController.onChange: Invalid cb, expected a function');
  }
  this.onChange_ = cb;
};

/** @return {!Object<string, ?>} */
yext.social.post.PostContentController.prototype.getData = function() {
  return $.extend(
    true,
    {},
    this.textContent.getData(),
    this.photoContent.getData(),
    this.linkContent.getData(),
    this.eventController.getData(),
    this.callToActionContent.getData());
};

yext.social.post.PostContentController.prototype.reset = function() {
  this.textContent.reset();
  this.photoContent.reset();
  this.linkContent.reset();
  this.eventController.reset();
  this.callToActionContent.reset();
};

/** Removes any photo content */
yext.social.post.PostContentController.prototype.clearPhotoContent = function() {
  this.photoContent.reset();
  this.abortPhotoUploadAjaxRequest();
};

yext.social.post.PostContentController.prototype.abortPhotoUploadAjaxRequest = function() {
  if (this.photoUploadAjaxRequest) {
    this.photoUploadAjaxRequest.abort();
  }
};

/** Updates the post content for a new field configuration */
yext.social.post.PostContentController.prototype.updateFieldConfiguration = function() {
  this.textContent.toggleEmbeddedFields(this.options.isFieldAllowed(
    yext.social.post.Partner.PostField.PROFILE_FIELDS));
  this.updateCharacterCount_();
};

/**
 * Populates the post box with the given content
 * @param {!Object<string, ?>} content
 */
yext.social.post.PostContentController.prototype.populate = function(content) {
  this.textContent.setMessage(content['message'] || '');
  if (content['hyperlink'] && content['hyperlink']['link']) {
    this.linkContent.setInitialLink(content['hyperlink']['link']);
    this.fetchLinkMetadata_(content['hyperlink']['link']);
  }
  this.photoContent.setPhoto(content['photo'] || {});
  this.eventController.setEvent(content['event'] || {});
  this.callToActionContent.setCallToAction(content['callToAction'] || {});
};

/** @private */
yext.social.post.PostContentController.prototype.bindLinkContentView_ = function() {
  this.linkContent.onChange(function(data) {
    if (this.onChange_) {
      this.onChange_(data);
    }
    this.updateCharacterCount_();
  }.bind(this));

  var url = this.linkContent.getData()['hyperlink']['link'];
  if (yext.isString(url)) {
    this.fetchLinkMetadata_(url);
  }
};

/** @private */
yext.social.post.PostContentController.prototype.bindPhotoContentView_ = function() {
  this.photoContent.onChange(function(data) {
    var asset = this.photoContent.getData()['asset'];
    var photo = this.photoContent.getData()['photo'];
    if (asset != null && photo === null) {
      this.uploadPhoto(asset);
      // TODO(slanden): Discuss this with product
      this.linkContent.reset();
    }

    if (this.onChange_) {
      this.onChange_(data);
    }

    this.updateCharacterCount_();
  }.bind(this));
};

/** @private */
yext.social.post.PostContentController.prototype.uploadPhoto = function(asset) {
  var shoulUploadFile = asset.file && !asset.croppedImage;
  var croppedImage;
  var croppedImageName;
  var photoUrl = asset.photoUrl;
  var assetId = asset.id;
  var sourceUrl = asset.sourceUrl;

  this.abortPhotoUploadAjaxRequest();

  if (shoulUploadFile) {
    var uploadFile = {
      action: yext.socialstorm.routes.SocialPost.uploadPhoto(),
      files: [asset.file],
      fileInputs: [asset.fileInputs],
      dataType: 'json',
      done: this.uploadPhotoSuccess.bind(this),
      error: this.uploadPhotoError.bind(this),
    };

    this.photoUploadAjaxRequest = yext.fileupload.upload(uploadFile);
  } else if (asset.croppedImage) {
    croppedImage = asset.croppedImage;
    croppedImageName = asset.photoUrl;
  }

  if (!shoulUploadFile) {
    var photoUploadData = {
      'croppedImage': croppedImage,
      'croppedImageName': croppedImageName,
      'sourceUrl': sourceUrl,
      'photoUrl': photoUrl,
      'assetId': assetId,
    };

    this.photoUploadAjaxRequest = $.ajax({
      url: yext.socialstorm.routes.SocialPost.uploadPhoto(),
      type: 'POST',
      data: photoUploadData,
      success: this.uploadPhotoSuccess.bind(this),
      error: this.uploadPhotoError.bind(this),
    });
  }
};

yext.social.post.PostContentController.prototype.uploadPhotoSuccess = function(data) {
  this.photoContent.setPhoto(data);
};

yext.social.post.PostContentController.prototype.uploadPhotoError = function(data) {
  // silently fail. it will be retried when user actually submits the post
};

/** @private */
yext.social.post.PostContentController.prototype.bindTextContentView_ = function() {
  var previousText = this.textContent.getData()['message'];
  this.textContent.onChange(function(data) {
    if (this.onChange_) {
      this.onChange_(data);
    }

    // don't require a space if >1 character has been added (indicating a paste)
    var charDifference = data['message'].length - previousText.length;
    if (this.shouldCheckForLink_(charDifference > 1)) {
      var matches = data['message'].match(yext.CONTAINS_SIMPLE_URL_REGEX);
      if (matches) {
        var url = matches[0];
        this.linkContent.setInitialLink(url);
        this.fetchLinkMetadata_(url);
      }
    }

    this.updateCharacterCount_();
    previousText = data['message'];
  }.bind(this));
};

/**
 * @param {boolean?=} opt_ignoreSpace if true, don't require that the message has a space
 * @private
 */
yext.social.post.PostContentController.prototype.shouldCheckForLink_ = function(opt_ignoreSpace) {
  var spacesRegex = /\s$/;
  return this.textContent.getData()['message'].length > 0
         && (opt_ignoreSpace || spacesRegex.test(this.textContent.getData()['message']))
         && !this.linkContent.getData()['hyperlink']['link']
         && !this.photoContent.getData()['asset'];
};

/**
 * @param {string} url
 * @private
 */
yext.social.post.PostContentController.prototype.fetchLinkMetadata_ = function(url) {
  yext.social.post.actions.fetchLinkMetadata({
    url: url,
    onSuccess: function(data) {
      var videoID = yext.youtube.parseIdFromUrl(url);
      var youtubeThumbnailUrl;
      if (videoID) {
        youtubeThumbnailUrl = yext.youtube.getYoutubeThumbnailUrl(videoID);
      }
      this.linkContent.fillInLinkMetadata(
        data['title'],
        data['subtitle'],
        data['description'],
        youtubeThumbnailUrl);
    }.bind(this),
    onFail: function() {
      this.linkContent.fillInLinkMetadata();
    }.bind(this),
  });
};

/** @private */
yext.social.post.PostContentController.prototype.updateCharacterCount_ = function() {
  var postData = $.extend(
    true,
    {},
    this.getData(),
    {'partnerIds': this.options.getPartnerIds()});
  var remainingChars = this.options.calculateRemainingCharacters(postData);
  var $charCount = this.$ctxt.find('.js-char-count-container');

  $charCount.toggle(remainingChars != null)
    .find('.js-char-count')
    .toggleClass('overcount', remainingChars < 0)
    .text(remainingChars);
};
